const AppName = "Learn nqilxʷcn with Sncəwips";
const Language = "WestBankOkanagan";
const Tribe = "West Bank";
const FirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY_WESTBANK,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_WESTBANK,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_WESTBANK,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_WESTBANK,
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_WESTBANK,
  appId: process.env.REACT_APP_FIREBASE_APP_ID_WESTBANK,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_WESTBANK,
};
const FilePath = "https://storage.googleapis.com/westbankcamedia/";
const NacaApiUrl = process.env.REACT_APP_NACA_API_URL || "https://naca.community";
const NacaCommunityId = "603797c9-a5f7-4ee1-9839-47d3d10e80a6";

const SheetsToPull = [
  { collection: "KZ_AppData", nameToSave: "vocabData" },
  { collection: "KZ_GameDescriptions", nameToSave: "gameDescriptions" },
  { collection: "KZ_GameFilterDataNew", nameToSave: "gameData" },
  { collection: "KZ_PopupWords", nameToSave: "popupWords" },
  { collection: "KZ_uiWords", nameToSave: "uiWords" },
];
const ParamsToFindGame = [
  { data: "category", param: "unit" },
  { data: "target", param: "game-name" },
  { data: "gameType", param: "game-type" },
];

const PossibleGames = [
  "Bubble Pop",
  // "Counting", // TODO: Re-enable on next data upload
  "Good Guess",
  "Matching",
  "Whack-A-Mole",
  "Word To Image",
  "Verb Activity",
  "Wordless",
  // "Item Fall",
  // "Solve It",
];
const NumberDataCategory = "Numbers";
// const NumberDataCategory = "Numbers Math"; // TODO: Re-enable on next data upload

const BottomColor = "rgba(83, 90, 41, 1.0)";

const VersionNumber = "2.03.00001";

const Credits = {
  credits: [
    "Learn nqilxwcn with Sncəwips",
    "Welcome to Our nqilxwcn/nsyilxcn Dictionary Site! We are pleased to have you join us. This space was created to support learners at all stages and to make it easier to explore and learn our language. Whether you are just beginning or continuing your learning journey, this dictionary is here to help you connect with the words, sounds, and teachings that carry our history, knowledge, and ways of being.",
    "We extend our sincere gratitude to all those who have contributed to this work. We especially honour our fluent speakers, language teachers, and language guardians - past and present, whose knowledge, dedication and generosity have been essential in sustaining and revitalizing our language for future generations. We also acknowledge the linguists and researchers whose careful documentation and collaboration have helped shape the language resources available today.",
    "We further recognize the many community members, learners, supporters, and partners who have contributed their time, insight, and encouragement throughout this journey. This dictionary stands as a collective effort and a reflection of shared responsibility to protect, nurture, and carry our language forward.",
    "Speakers and Elders: Delphine Armstrong, Eleanor Eli, Perry Joe-Williams",
    "Sncəwips and WFN Language & Culture Staff: Michelle Joe, Quentin Scott, Brock Harper, Coralee Miller, Sadie Clough, Michelle Bolan, Sacheen Lindley",
    "References:",
    "Bouchard, R. (2002). Classified Okanagan Indian Language Word List. (By Larry Pierre & Martin Louie, fluent speakers; J. Armstrong, M. Baptiste, D. Derickson, T. A. Terbasket, D. Johnson, T. Lindley, K. Michel, R. Caldwell, W. Barnes, P. Kruger, J. Kruger, J. Kruger, N. Phillip, M. Squakin, B. Marchand, G. Roberds, M. Roberds, F. Roberds, Rev. ed.). Okanagan Indian Educational Resources Society. (Original work published 1975).",
    "En'owkin Cenre. (1993). suknaqínx ɬaʔ ksʔaʔúm iʔ ta nq́ lxwcən - Okanagan Indian Language Pronounciation Drills.",
    "Mattina, A. (1987). Colville-Okanagan dictionary (P. J. Seymour, M. Desautel, C. Jack, D. Desautel, E. Jack, H. Manuel, H. Toulou, S. McDonald, M. Lemery, J. Quintasket, C. Smith, C. Andrews, G. Quintasket, C. Quintasket, A. Louie, L. Pierre, M. Louie, G. Lazard, & R. Bouchard, Contributors). Department of Anthropology, University of Montana.",
    "Okanagan Nation Alliance (2021). Iʔ spl̓laɬ̣q t̓l iʔ sukənaʔqi̓n – Plants of the Okanagan.",
    "Sʔamtíc̀ aʔ Peterson, S., Ńʔiýsítaʔtkw Wiley, L., & ʕAńń Parkin, C. (2018). Ńsəĺxčiń 1 - A Beginning Course in Colville-Okanagan Salish (3rd ed.) Salish School of Spokane.",
    "Turner, N. J., Bouchard, R., & Kennedy, D. I. D. (1980). Ethnobotany of the Okanagan-Colville Indians of British Columbia and Washington (Issue 21 of Occasional papers of the British Columbia Provincial Museum). British Columbia Provincial Museum.",
    "Stay Connected! For inquiries or more information about our language dictionary, please feel free to reach out to Michelle Joe at mjoe@wfn.ca. Thank you for visiting, and we hope you enjoy your learning experience!",
    "All Content and Language © Sncəwips Heritage Museum",
    "Developed by Sncəwips Heritage Museum Language and Culture Department",
    "Website created and designed through Native Teaching Aids LLC by Thomas Koefod and Spencer Kittle",
  ],
  links: [
    {
      link: "https://www.sncewips.com",
      image: "sncewips_logo.png",
      style: "tall",
    },
    {
      link: "https://www.nativeteachingaids.com",
      image: "ntalogo.png",
      style: "short",
    },
  ],
};

const config = {
  AppName,
  Language,
  Tribe,
  FirebaseConfig,
  FilePath,
  NacaApiUrl,
  NacaCommunityId,
  SheetsToPull,
  ParamsToFindGame,
  BottomColor,
  NumberDataCategory,
  VersionNumber,
  Credits,
  PossibleGames,
};

export default config;

export {
  AppName,
  Language,
  Tribe,
  FirebaseConfig,
  FilePath,
  NacaApiUrl,
  NacaCommunityId,
  SheetsToPull,
  ParamsToFindGame,
  BottomColor,
  NumberDataCategory,
  VersionNumber,
  Credits,
  PossibleGames,
};
